import { useQuery } from '@tanstack/react-query';
import { useAxios } from '../../../api/axios';
import { useTranslation } from 'react-i18next';

export const useUploadUrl = (investorObj: any) => {
  const axios = useAxios();
  const { t } = useTranslation();
  const urlKey = t('upload-url-api');
  const contactId = investorObj?.id;
  const needsPofUpload = !!investorObj?.uploadPOF;

  const Query = useQuery({
    queryKey: ['upload-url-list', contactId],
    queryFn: async () => {
      const res = await axios.get(`${urlKey}/${contactId}`);
      return res?.data?.data;
    },
    enabled: !!contactId && needsPofUpload,
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });

  return Query;
};
